module.exports = __webpack_public_path__ + "static/media/icon-unknown.b8367488.svg";